var _path, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinCafe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 80,
    viewBox: "0 0 55 80",
    color: "#484848",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1562 26.4039C54.1562 40.9864 27.1562 80 27.1562 80C27.1562 80 0.15625 40.9864 0.15625 26.4039C0.15625 11.8214 12.2446 0 27.1562 0C42.0679 0 54.1562 11.8214 54.1562 26.4039Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7531,
    cy: 26.0099,
    rx: 18.5373,
    ry: 18.1281,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9587 33.1666H34.4112C35.1462 33.1666 35.75 32.6249 35.8375 31.9416L37.2812 18.2083H32.9062V14.8333H31.1825V18.2083H26.8338L27.0962 20.1583C28.5925 20.5499 29.9925 21.2583 30.8325 22.0416C32.0925 23.2249 32.9587 24.4499 32.9587 26.4499V33.1666ZM18.0312 32.3333V31.4999H31.1825V32.3333C31.1825 32.7833 30.7887 33.1666 30.2812 33.1666H18.9062C18.425 33.1666 18.0312 32.7833 18.0312 32.3333ZM31.1825 26.4999C31.1825 19.8333 18.0312 19.8333 18.0312 26.4999H31.1825ZM18.0312 28.1666H31.1562V29.8333H18.0312V28.1666Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinCafe);
export default __webpack_public_path__ + "static/media/pin-cafe.1e131dc056370e7d4d46ce5d58c563ec.svg";
export { ForwardRef as ReactComponent };